import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-thumbs-up',
  templateUrl: './svg-thumbs-up.component.html',
  styleUrls: ['./svg-thumbs-up.component.css']
})
export class SvgThumbsUpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
